import { UIText2 } from '@cian/ui-kit/typography';

import { Thumbnail } from './Thumbnail';
import styles from './Thumbnails.css';
import { IMedia } from '../../types';

interface IThumbnailsProps {
  media: Array<IMedia | null>;
  hasMore?: boolean;
}

export function Thumbnails({ media, hasMore }: IThumbnailsProps) {
  return (
    <div className={styles['wrapper']}>
      {media.map((thumbnail, i) => (
        <Thumbnail key={`thumbnail-${i}`} media={thumbnail}>
          {hasMore && i === media.length - 1 && (
            <div className={styles['overlay']}>
              <UIText2 color="text-inverted-default">Ещё фото</UIText2>
            </div>
          )}
        </Thumbnail>
      ))}
    </div>
  );
}
